import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ADAdvancedSettings from './add-donation-components/ADAdvancedSettings';
import ADDonationDetails from './add-donation-components/ADDonationDetails';
import ADScheduleDonations from './add-donation-components/ADScheduleDonations';
import ADSelectDonor from './add-donation-components/ADSelectDonor';
import ADSelectedAppeals from './add-donation-components/ADSelectedAppeals';

const AddDonation = () => {
  const [validated, setValidated] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <div className={'py-0 mx-auto'} style={{ maxWidth: '820px' }}>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <ADSelectDonor />
        <ADDonationDetails />
        <ADSelectedAppeals />
        <ADAdvancedSettings />
        <ADScheduleDonations />
        <Button
          // type="submit"
          onClick={() => navigate('/pay_now')}
          size="lg"
          variant="success"
          className="w-100 py-3 mt-3 fs-0 fs-md-1"
        >
          Save And Continue To Payments
        </Button>
      </Form>
    </div>
  );
};

export default AddDonation;
